export default Backbone.View.extend({
  // A view for showing the the pagination of results at the
  // bottom of the page.  It takes a SearchResults object as its model
  // and updates itself that changes.  It also has a reference to
  // the Query model for updating it when a page button is clicked.

  BOOTPAG_DEFAULTS: {
    leaps: false,
    maxVisible: 7,
  },

  el: '.js-search-results-pagination-view',

  initialize(options) {
    this.query = options.query;

    // Set up bootpag
    this.$pagination = this.$('.js-search-results-pagination');
    this.updateBootpag();
    this.$pagination.on('page', _.bind(this.onPageChange, this));

    // Watch for model updates
    this.model.on('change', _.bind(this.onSearchResultsChanged, this));
  },

  onSearchResultsChanged() {
    this.updateBootpag();
  },

  updateBootpag(create) {
    let pageCount = 1;
    let page = 1;

    if (this.model.has('page_count')) {
      pageCount = this.model.get('page_count');
      page = this.model.get('page_number');
    }

    const options = _.defaults({}, this.BOOTPAG_DEFAULTS, {
      total: pageCount,
      page,
      wrapClass: 'rover-pagination',
      next: '<span class="rover-icon rover-icon-in-right"></span>',
      prev: '<span class="rover-icon rover-icon-in-left"></span>',
    });

    this.$pagination.bootpag(options);

    // Show/hide based on the number of results
    if (this.model.get('result_count')) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
  },

  onPageChange(event, num) {
    this.query.set('page', num);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_results_pagination_view.js